<ul [attr.aria-labelledby]="labelledby" [class.block]="block" class="tag-list" role="group">
  @for (tag of currentTags; track tag) {
    <li>
      <button (click)="toggle(tag)" [attr.aria-checked]="isChecked(tag)" class="tag-button" role="checkbox"
        type="button">
        <app-tag [status]="tag.status">{{ tag.name }}</app-tag>
      </button>
    </li>
  }
</ul>
